(() => {
  // Sections can appear multiple times and be replaced in the theme editor.
  if (window.cardsWithCTAInitialized) return;
  window.cardsWithCTAInitialized = true;

  let shopifyFormsTimer;
  let embedReadyTimer;
  const formRoots = new Map();

  function syncShopifyFormStyles() {
    window.clearTimeout(embedReadyTimer);
    // The section marker remains present when a login-only CTA is not rendered.
    const buttonOnly = Boolean(document.querySelector('[data-section-type="cards-with-cta"][data-shopify-forms-button-only]'));
    let waitingForRoot = false;

    for (const embed of document.querySelectorAll('shopify-forms-embed')) {
      const root = embed.shadowRoot;
      if (!root) {
        waitingForRoot = true;
        continue;
      }

      if (!formRoots.has(root)) {
        const observer = new MutationObserver(syncShopifyFormStyles);
        observer.observe(root, { childList: true, subtree: true });
        const legendSheet = new CSSStyleSheet();
        legendSheet.replaceSync('legend { font-weight: 700 !important; }');
        formRoots.set(root, { embed, observer, popupSheet: null, legendSheet });
      }

      const state = formRoots.get(root);
      // Adopt styles without inserting nodes into Shopify's rendered form markup.
      if (!root.adoptedStyleSheets.includes(state.legendSheet)) {
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, state.legendSheet];
      }

      // Identify popup embeds by their teaser; inline forms keep their normal display.
      if (buttonOnly && root.querySelector('button[class*="_teaser"]')) {
        if (!state.popupSheet) {
          state.popupSheet = new CSSStyleSheet();
          state.popupSheet.replaceSync(`
            :host(:not([data-cards-cta-opened])) { display: none !important; }
            button[class*="_teaser"] { display: none !important; }
          `);
        }
      } else if (!buttonOnly && state.popupSheet) {
        root.adoptedStyleSheets = root.adoptedStyleSheets.filter(sheet => sheet !== state.popupSheet);
        state.popupSheet = null;
      }

      if (state.popupSheet && !root.adoptedStyleSheets.includes(state.popupSheet)) {
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, state.popupSheet];
      }
    }

    for (const [root, state] of formRoots) {
      if (!state.embed.isConnected) {
        state.observer.disconnect();
        formRoots.delete(root);
      }
    }

    if (waitingForRoot) {
      embedReadyTimer = window.setTimeout(syncShopifyFormStyles, 250);
    }
  }

  function openShopifyForm(attempt = 0) {
    // Forms loads asynchronously. Only open one popup and leave inline forms alone.
    for (const embed of document.querySelectorAll('shopify-forms-embed')) {
      const teaser = embed.shadowRoot?.querySelector('button[class*="_teaser"]');
      if (!teaser) continue;

      embed.setAttribute('reveal', 'true');
      embed.setAttribute('data-cards-cta-opened', 'true');
      teaser.click();
      return;
    }

    if (attempt < 20) {
      shopifyFormsTimer = window.setTimeout(() => openShopifyForm(attempt + 1), 250);
    } else {
      console.warn('Cards with CTA: No Shopify Forms popup teaser found. Enable the Forms app embed and configure the popup teaser to show first on this page.');
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-section-type="cards-with-cta"] [data-klaviyo-form-id], [data-section-type="cards-with-cta"] [data-shopify-forms-trigger]');
    if (!trigger) return;

    if (trigger.hasAttribute('data-shopify-forms-trigger')) {
      window.clearTimeout(shopifyFormsTimer);
      openShopifyForm();
      return;
    }

    const formId = trigger.dataset.klaviyoFormId.trim();
    if (!formId) return;

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });

  // Register clicks before styling so form initialization cannot prevent the CTA handler.
  // App embeds and theme-editor sections can be inserted after this script runs.
  new MutationObserver(syncShopifyFormStyles).observe(document.body, { childList: true, subtree: true });
  syncShopifyFormStyles();
})();
